import { useEffect, useState } from "react";
import { useRouteMatch } from "react-router-dom";
import { UserEntity } from "@lifeat/shared/data-models/user/UserEntity";
import { Routes } from "@lifeat/shared/system/RouteConstants";
import { callMonolith } from "@service/ServerlessFunctionsService";
import { buildRoute } from "@util/RouteUtil";
import { AdminError } from "../../features/admin/AdminError";
import { AdminUserControls } from "../../features/admin/AdminUserControls";
import LoadingView from "../../features/virtual-space/components/SpaceView/LoadingView/LoadingView";

type State =
    | {
          type: "loading";
      }
    | {
          type: "loaded";
          uid: string;
          userData: UserEntity;
      }
    | {
          type: "error";
          message: string;
      };

export function AdminUserByEmailPage() {
    const [state, setState] = useState<State>({ type: "loading" });
    const match = useRouteMatch<Record<"emailBase64", string>>(buildRoute(Routes.AdminUserByEmail, ":emailBase64"));

    useEffect(() => {
        setState({ type: "loading" });

        callMonolith("admin-get-user-by-email", { email: atob(match.params.emailBase64) })
            .then((res) => {
                if (res) {
                    setState({ type: "loaded", uid: res.uid, userData: res.userData });
                } else {
                    setState({ type: "error", message: "User not found" });
                }
            })
            .catch((e) => setState({ type: "error", message: String(e) }));
    }, [match.params.emailBase64]);

    if (state.type === "loading") {
        return <LoadingView isAppLoading />;
    }
    if (state.type === "error") {
        return <AdminError message={state.message} />;
    }
    return <AdminUserControls uid={state.uid} userData={state.userData} />;
}
